import { inject, Injectable } from '@angular/core';
import { GroupHttpService } from './group-http.service';
import { NewGroupHttpService } from './new-group-http.service';
import { FeatureFlagService } from '../featureFlag.service';
import { DevelopmentFlag } from '../../models/feature-flag.model';
import { GroupInsertDto } from '../../dtos/groupInsertDto';
import { GroupUpdateDto } from '../../dtos/groupUpdateDto';
import { GroupResponseDto } from '../../dtos/groupResponseDto';
import { UserLoginService } from '../user-login.service';
import { Observable, switchMap } from 'rxjs';
import { Pagination } from '../../models/pagination';
import { appendAgentAssignmentFilter } from './agent-assignment-filter';

@Injectable({ providedIn: 'root' })
export class FeatureFlaggedGroupHttpService extends GroupHttpService {

    private _newService = inject(NewGroupHttpService);
    private _featureFlagService = inject(FeatureFlagService);
    private _loginService = inject(UserLoginService);

    private get useNewApi(): boolean {
        /*TODO: DELETE ALL OF THAT TO MAKE IT ACCESSIBLE TO EVERYONE*/
        return true || this._featureFlagService.doesClientsHaveFeatures([DevelopmentFlag.NEW_GROUP_API]) || this._featureFlagService.doesClientsHaveSettings([DevelopmentFlag.NEW_GROUP_API]);
    }

    override insert(object: GroupInsertDto): Observable<GroupResponseDto> {
        if (this.useNewApi) {
            return this._newService.insert(object);
        }
        return super.insert(object);
    }

    override update(id: number | string, object: GroupUpdateDto): Observable<GroupResponseDto> {
        if (this.useNewApi) {
            return this._newService.update(id, object);
        }
        return super.update(id, object);
    }

    override delete(id: number | string): Observable<any> {
        if (this.useNewApi) {
            return this._newService.delete(id);
        }
        return super.delete(id);
    }

    override findById(id: number | string): Observable<GroupResponseDto> {
        return super.findById(id);
    }

    override findAll(): Observable<GroupResponseDto[]> {
        return this.findAllWithFilters('');
    }

    override findAllWithFilters(filters: string, sortBy?: string, direction?: string): Observable<GroupResponseDto[]> {
        if (this.useNewApi) {
            return this.getHasAssignments().pipe(
                switchMap(hasAssignments => {
                    let finalFilters = filters;
                    if (hasAssignments) {
                        const user = this._loginService.getUserObjectField('BUSINESS_ACCOUNT');
                        finalFilters = appendAgentAssignmentFilter(finalFilters, user.userId);
                    }
                    return this._newService.findAllWithFilters(finalFilters, sortBy, direction);
                })
            );
        }
        return super.findAllWithFilters(filters, sortBy, direction);
    }

    override findAllWithPagesAndFilters(filters: string, page: number, size: number, sortBy?: string, direction?: string): Observable<Pagination<GroupResponseDto>> {
        if (this.useNewApi) {
            return this.getHasAssignments().pipe(
                switchMap(hasAssignments => {
                    let finalFilters = filters;
                    if (hasAssignments) {
                        const user = this._loginService.getUserObjectField('BUSINESS_ACCOUNT');
                        finalFilters = appendAgentAssignmentFilter(finalFilters, user.userId);
                    }
                    return this._newService.findAllWithPagesAndFilters(finalFilters, page, size, sortBy, direction);
                })
            );
        }
        return super.findAllWithPagesAndFilters(filters, page, size, sortBy, direction);
    }
}

